// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MIC_2020_YEAR_PAGE_LOADING() {
      return {
        isLoading: true,
        mic2020YearPage: {} // action.micYearPage
      };
    },
    MIC_2020_YEAR_PAGE_LOADED() {
      return {
        isLoading: false,
        data: {} // action.micYearPage
      };
    },
    MIC_2020_YEAR_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mic2020YearPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
